// extracted by mini-css-extract-plugin
export default {"logo":"login_logo__8LRfQ"};